// PAY ATTENTION: name angular wrapper as [COMPONENT_NAME].angular.ts[x]
const dependencies = importAngularDependencies(
  require.context(
    './',
    true,
    /^(?!.*\.(spec|test)\.(angular)\.(tsx|ts)$).*\.(angular)\.(tsx|ts)$/u
  ),
  './banners.js'
);

export default angular.module('doxy.banners', dependencies).name;
